export default __webpack_public_path__ + "static/media/Makan_logistics_management.afe9bb7c.png";